import React, {useState} from 'react';
import ClientAccountCard from './ClientAccountCard';
import ClientAccountUpdateCard from './ClientAccountUpdateCard';

const ClientAccountContainer: React.FC = () => {
    const [isEditMode, setIsEditMode] = useState(false);

    return isEditMode ? (
        // 클라이언트 계정 정보 수정
        <ClientAccountUpdateCard onCancel={() => setIsEditMode(false)}/>
    ) : (
        // 클라이언트 계정 정보 조회
        <ClientAccountCard onModify={() => setIsEditMode(true)}/>
    );
};

export default ClientAccountContainer;